import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { animeCategories, siteInfo } from '@/mocks/animeData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled || !isHome ? 'bg-background-50/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <Link to="/" className="flex items-center gap-2 font-heading text-2xl font-bold text-primary-500 whitespace-nowrap">
            <i className="ri-play-circle-fill text-3xl"></i>
            <span>{siteInfo.name}</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${location.pathname === '/' ? 'text-primary-500 bg-primary-50' : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white hover:text-primary-200'}`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-1 whitespace-nowrap ${location.pathname.startsWith('/category') ? 'text-primary-500 bg-primary-50' : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white hover:text-primary-200'}`}
              >
                分类浏览
                <i className={`ri-arrow-down-s-line transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-background-50 rounded-xl shadow-lg border border-background-200 py-2 z-50">
                  {animeCategories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      <i className={`${cat.icon} text-base w-5 h-5 flex items-center justify-center`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${location.pathname === '/about' ? 'text-primary-500 bg-primary-50' : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white hover:text-primary-200'}`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <button className="w-10 h-10 flex items-center justify-center rounded-lg text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap" aria-label="搜索">
              <i className="ri-search-line text-lg"></i>
            </button>
            <button className="px-5 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              登录/注册
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 cursor-pointer whitespace-nowrap"
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200 bg-background-50 py-4 px-4">
            <div className="flex flex-col gap-1">
              <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap">
                首页
              </Link>
              <div className="text-sm font-medium text-foreground-500 px-4 py-2 whitespace-nowrap">分类浏览</div>
              {animeCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-3 pl-8 pr-4 py-2.5 text-sm text-foreground-600 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  <i className={`${cat.icon} text-sm w-4 h-4 flex items-center justify-center`}></i>
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap">
                关于我们
              </Link>
              <button className="mt-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap w-full">
                登录/注册
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}